import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRouteByAccountType } from '../../../routes/getRouteByAccountType';
import { di } from '../../../state/inversify.config';
import { ReportIncidentDumb } from '../dumb/reportIncident.dumb';
import { CreateIncidentDomainService } from '../createIncidentDomainService';
import { AuthService } from '../../../state/helperServices/auth/auth.service';
import { isValidDateTime } from '../createIncident.helper';

interface ReportIncidentProps {
  symptomQuestion: string;
  goBackText?: string;
  goNextText?: string;
  children?: any;
}

export function ReportIncidentSmart({
  symptomQuestion,
  children,
  goBackText,
  goNextText,
}: ReportIncidentProps) {
  const navigate = useNavigate();
  const totalStep = 4;
  const otherVal: string = 'OTHER';
  const [nextDisabled, setNextDisabled] = useState(false);
  // TODO: move into a domainService and only return accountType or even better find a way so that you don't have to send down the accountType
  const authService = di.get<AuthService>(AuthService);
  const loggedInUser = authService.useLoggedInUserSelector();

  const createIncidentDomainService = di.get<CreateIncidentDomainService>(
    CreateIncidentDomainService,
  );
  const incidentViewServiceSelector =
    createIncidentDomainService.useIncidentCreateViewSelector();
  const activeStep = createIncidentDomainService.useActiveStepSelector();
  const queryParams =
    createIncidentDomainService.useIncidentQueryParamsSelector();
  const isValidIncidentDateTime =
    createIncidentDomainService.useIncidentDateTimeValidationSelector();

  const onNext = () => {
    const {
      incidentDateTime,
      redFlags,
      activity,
      activityOther,
      sessionType,
      sessionTypeOther,
      playType,
      playTypeOther,
      headImpactType,
      headImpactTypeOther,
    } = incidentViewServiceSelector;
    if (activeStep === 3) {
      createIncidentDomainService.dispatchCreateIncident({
        incidentDateTime,
        playerId: queryParams?.selectedPlayerId,
        report: {
          activity,
          activityOther,
          sessionType,
          sessionTypeOther,
          playType,
          playTypeOther,
          headImpactType,
          headImpactTypeOther,
          pass: true,
          redFlags,
        },
      });
    }
    createIncidentDomainService.dispatchNextPageQuery();
  };

  const onPrev = () => {
    createIncidentDomainService.dispatchPreviousPageQuery();
  };

  const onRedirectToHome = () => {
    createIncidentDomainService.dispatchResetStep();
    navigate(`/${getRouteByAccountType(loggedInUser?.accountType)}`);
  };

  useEffect(() => {
    const {
      incidentDateTime,
      redFlags,
      activity,
      activityOther,
      sessionType,
      sessionTypeOther,
      playType,
      playTypeOther,
      headImpactType,
      headImpactTypeOther,
    } = incidentViewServiceSelector;
    if (activeStep === 1) {
      setNextDisabled(redFlags === undefined);
    } else if (activeStep === 2) {
      if (!isValidIncidentDateTime) {
        setNextDisabled(true);
      } else if (!isValidDateTime(incidentDateTime as string)) {
        setNextDisabled(true);
      } else if (activityOther === '' && activity === otherVal) {
        setNextDisabled(true);
      } else if (sessionTypeOther === '' && sessionType === otherVal) {
        setNextDisabled(true);
      } else if (headImpactTypeOther === '' && headImpactType === otherVal) {
        setNextDisabled(true);
      } else if (playTypeOther === '' && playType === otherVal) {
        setNextDisabled(true);
      } else if (
        activity === '' ||
        playType === '' ||
        sessionType === '' ||
        headImpactType === ''
      ) {
        setNextDisabled(true);
      } else {
        setNextDisabled(false);
      }
    } else {
      setNextDisabled(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStep, incidentViewServiceSelector, isValidIncidentDateTime]);

  return (
    <ReportIncidentDumb
      onNextDisabled={nextDisabled}
      symptomQuestion={symptomQuestion}
      goBackText={goBackText}
      onGoBack={onPrev}
      activeStep={activeStep}
      totalStep={totalStep}
      onGoNext={onNext}
      goNextText={goNextText}
      onCloseReportIncidentPage={onRedirectToHome}
    >
      {children}
    </ReportIncidentDumb>
  );
}
